/**
 * Semantic spacing scale.
 *
 * All values are Chakra spacing units (1 unit = 4px). Use these named tokens
 * instead of raw numbers so that paddings/gaps stay consistent across the app.
 *
 * Density tiers map to specific component contexts so cards/forms/tiles all
 * agree on what "comfortable" or "compact" means.
 */

export const density = {
  compact: 3, // 12px - dense tables, inline chips, tight stacks
  comfortable: 5, // 20px - default card padding, form rows
  spacious: 8, // 32px - hero KPI tiles, marketing-style sections
} as const;

export const spacing = {
  // Card-level
  cardPadding: density.comfortable,
  cardHeaderPadding: density.comfortable,
  cardBodyPadding: density.comfortable,
  cardGap: 4, // gap between header and body inside a card

  // Section-level (between cards on a page)
  sectionGap: 6, // 24px - between major dashboard sections
  rowGap: 5, // 20px - between cards in a single grid row
  pageTopPadding: 8, // 32px - top of every admin page

  // Tile / KPI
  tilePadding: density.comfortable,
  tileGap: 2, // gap between tile pre-header and value

  // Form
  fieldGap: 4, // gap between form fields (vertical stack)
  inlineGap: 3, // gap between inline buttons / chips
} as const;

export type Density = keyof typeof density;
export type SpacingToken = keyof typeof spacing;
